import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { href } from "react-router-dom";

import { DEFAULT_LANGUAGE } from "@/constants/languages";
import { LOCALE_PARAM } from "@/constants/routes";

function useLocalizedHref() {
  const { i18n } = useTranslation();

  const currentLanguage = i18n.language.split("-")[0];

  return useCallback(
    (path: string, params?: Record<string, string | undefined>): string => {
      const locale =
        currentLanguage === DEFAULT_LANGUAGE ? undefined : currentLanguage;

      return href(path, { [LOCALE_PARAM]: locale, ...params });
    },
    [currentLanguage]
  );
}

export default useLocalizedHref;
